<div class="modal fade" id={{modelId}} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            Commission Details
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                        data-dismiss="modal" (click)="onDismiss()">
                </div>
                <hr>
                <div>
                    <form [formGroup]="commissionForm" #data>
                        <div class="">
                            <label class="lblInput" for="title">Table reservation commission per head</label><span
                                style="color: #DC4A4A; padding: 2px;;">*</span>
                            <input type="number" class="form-control input" formControlName="tbl_commission_per_head"
                                data-style="dropdownCustomStyle"
                                [ngClass]="{ 'is-invalid': submitted && controls.tbl_commission_per_head.errors?.required}">
                            <div class="text-danger">
                                <div *ngIf="submitted && controls.tbl_commission_per_head.errors">
                                    Table reservation commission per head is required!
                                </div>
                            </div>
                        </div>
                        <div class="mt-2">
                            <label class="lblInput" for="title">Table reservation referral commission per
                                head</label><span style="color: #DC4A4A; padding: 2px;;">*</span>
                            <input type="number" class="form-control input"
                                formControlName="tbl_ref_commission_per_head" data-style="dropdownCustomStyle"
                                [ngClass]="{ 'is-invalid': submitted && controls.tbl_ref_commission_per_head.errors?.required}">
                            <div class="text-danger">
                                <div *ngIf="submitted && controls.tbl_ref_commission_per_head.errors">
                                    Table reservation referral commission per is required!
                                </div>
                            </div>
                        </div>
                        <div class="mt-2">
                            <label class="lblInput" for="title">Stripe Account ID</label><span
                                style="color: #DC4A4A; padding: 2px;;">*</span>
                            <input type="text" class="form-control input" formControlName="transfer_destination"
                                data-style="dropdownCustomStyle"
                                [ngClass]="{ 'is-invalid': submitted && controls.transfer_destination.errors?.required}">
                            <div class="text-danger">
                                <div *ngIf="submitted && controls.transfer_destination.errors">
                                    Stripe Account ID is required!
                                </div>
                            </div>
                        </div>
                        <div class="mt-2">
                            <label class="lblInput" for="title">Payment Account</label><span
                                style="color: #DC4A4A; padding: 2px;;">*</span>
                            <div class="radioButtonsContainer">
                                <div class="columnRowContainer">
                                    <input type="radio" class="itemCheck marginRight" name="delivergate_account"
                                        formControlName="delivergate_account" id="delivergate" value="1">
                                    <h5 class="headingText">Delivergate Account</h5>
                                </div>
                                <div class="columnRowContainer ml-2">
                                    <input type="radio" class="itemCheck marginRight" name="delivergate_account"
                                        formControlName="delivergate_account" id="customer" value="0">
                                    <h5 class="headingText">Customer Account</h5>
                                </div>
                            </div>
                            <div class="text-danger">
                                <div *ngIf="submitted && controls.delivergate_account.errors">
                                    Payment Account is required!
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="mt-2 mb-0" *ngIf="submitted">
                        <p class="alert alert-success m-0" *ngIf="success && message != ''">
                            {{message}}
                        </p>
                        <p class="alert alert-danger m-0" *ngIf="!success && message != ''">
                            {{message}}
                        </p>
                    </div>
                    <div class="col-md-12 modal-button-div mt-2">
                        <button class="btn modal-btn-button" type="button" (click)="onSaveChanges()">
                            <span *ngIf="!loading">Save Changes</span>
                            <div *ngIf="loading" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>